import { Link } from 'react-router-dom';
import * as AlertNotification from '@givebutter/primitives/alert-notification';
import { useStripeNotifications } from 'assets/js/pages/payouts/StripeNotificationsContext';
import { useFetchPayoutAccount } from 'assets/js/pages/payouts/useFetchPayoutAccount';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const PayoutsSettingsAlert = () => {
    const { accountId } = useCurrentAccount();
    const { hasFetchedNotifications, hasNotifications } = useStripeNotifications();
    const { data: payoutAccount } = useFetchPayoutAccount();
    const payoutAccountData = payoutAccount.data;
    const showSettingsAlert =
        payoutAccountData?.merchant_onboarding_complete &&
        payoutAccountData?.merchant_account_type === 'custom' &&
        payoutAccountData?.merchant_status === 'pending' &&
        hasFetchedNotifications &&
        !hasNotifications;

    if (!showSettingsAlert) {
        return null;
    }

    return (
        <AlertNotification.Root type="warning">
            <AlertNotification.Icon />
            <AlertNotification.Content>
                <AlertNotification.Title>
                    Your Stripe account is missing information.{' '}
                    <Link
                        to={`/accounts/${accountId}/payouts/settings`}
                        className={'text-orange-700 underline hover:text-orange-700'}
                    >
                        Update in settings &rarr;
                    </Link>
                </AlertNotification.Title>
            </AlertNotification.Content>
        </AlertNotification.Root>
    );
};

export { PayoutsSettingsAlert };
